import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { useState, useEffect } from 'react'
import GraphView from './GraphView'
import Overlay from './Overlay'
import './index.scss'

RightPanel = ({ currentNode, currentTable, isCreatingNode, isEditingNode, left, match: { path } }) ->

  overlayIsVisible = currentNode or currentTable or isCreatingNode or isEditingNode

  <div>
    <GraphView isHidden={overlayIsVisible} left={left} />
    {if overlayIsVisible
      props = { nodeId: currentNode, tableConf: currentTable, isCreatingNode, isEditingNode, left }
      <Overlay {props...} />
    }
  </div>

mapStateToProps = ({ explore }) ->
  {
    currentNode: explore.detailPopupNode
    currentTable: explore.tableConfig
    isCreatingNode: explore.isCreatingNode
    isEditingNode: explore.isEditingNode
  }

export default withRouter(connect(
  mapStateToProps
)(RightPanel))
